/** Staff sign-in: Cloudflare Access in production, dev bypass token pasted locally. */
import { field, h } from "../dom-helpers";
import type { RenderedScreen, ScannerApp } from "../scanner-app-context";
import { getDevToken, setDevToken } from "../staff-api-client";
import { strings } from "../strings";

export function renderSignIn(app: ScannerApp, expired: boolean): RenderedScreen {
  const token = h("input", { type: "password", name: "devToken", autocomplete: "off", value: getDevToken() ?? "" });
  const next = () => app.navigate(app.till ? { name: "scan" } : { name: "till" });

  const form = h(
    "form",
    {
      className: "card stack",
      onsubmit: (event: Event) => {
        event.preventDefault();
        const value = token.value.trim();
        if (!value) {
          token.focus();
          return;
        }
        setDevToken(value);
        next();
      },
    },
    h("h2", {}, strings.signInTitle),
    expired ? h("p", { className: "error", role: "alert" }, strings.sessionExpired) : null,
    h("p", { className: "muted" }, strings.signInAccessNote),
    field(strings.signInDevLabel, token),
    h("p", { className: "hint" }, strings.signInDevHint),
    h("button", { type: "submit", className: "primary" }, strings.signInContinue),
    h(
      "button",
      {
        type: "button",
        className: "ghost",
        onclick: () => {
          setDevToken(null);
          next();
        },
      },
      strings.signInViaAccess,
    ),
  );
  return { el: form };
}
